import axios from "axios";
import config from "@/config/constants.js";
import $router from '@/router/index.js';
import {firestore} from "@/config/firebase";

export default {
    namespaced: true,
    state: {
        status: "",
        user: {},
        billing: JSON.parse(localStorage.getItem('sign_up_billing')) || {},
    },
    mutations: {
        loading(state) {
            state.status = "loading";
        },
        status(state, status) {
            state.status = status;
        },
        success(state, user) {
            state.user = user;
            state.status = "";
            // localStorage.setItem('sign_up_owner', JSON.stringify(user));
        }
    },
    actions: {
        signup_owner: function ({commit}, data) {

            let params = data;

            params['phone_number'] = params['phone_number'].replaceAll(' ', '').replaceAll('-', '');
            params['phone_number'] = config.phone_extension + params['phone_number'];
            params['no_owner'] = true;
            params['billing_active'] = true;

            return new Promise(function (resolve, reject) {
                commit("loading");
                axios.post(config.api_url + 'signup_owner', params)
                    .then(response => {
                        if (response.data.code === "ERROR") {
                            commit("status", "error");
                            reject(response.data.message);
                        } else {
                            commit("success", response.data.user);
                            resolve(response);
                        }
                    })
                    .catch(err => {
                        commit("status", "error");
                        reject(err.response.data.message);
                    })
            });
        },
        change_state_login: function () {
            const user = localStorage.getItem(config.token_key);
            const parse = JSON.parse(user);
            const key = {
                "user_id": parse.phone_number,
                "tenant_id": parse.tenant_id
            };
            return new Promise(function (resolve, reject) {
                axios.post(config.api_url + 'user_access_login', key)
                    .then(response => {
                        // Post-signup add_users/add_vendors chain has been
                        // removed — fall back to the admin panel.
                        $router.push("/owner/owner-admin-panel");
                        resolve(response);
                    })
                    .catch(err => {
                        reject(err.response.data.message);
                    })
            });
        },
        // Single-page subscribe action for the new /sign_up flow. Combines
        // signup_owner + Stripe customer + Stripe subscription in one
        // backend call (the new POST /v1/signup_owner_with_subscription
        // endpoint). The caller has already used Stripe Elements +
        // confirmSetup() to obtain a succeeded SetupIntent — we just hand
        // its id over to the backend along with the rest of the form data.
        //
        // Returns the raw axios response on success; throws on rejection
        // so the component can render the per-error fallback UI.
        signupWithSubscription: function ({ commit }, data) {
            let params = { ...data };
            params['phone_number'] = params['phone_number']
                .replaceAll(' ', '').replaceAll('-', '');
            params['phone_number'] = config.phone_extension + params['phone_number'];
            // Default ToS / billing-terms versions if the form omitted them
            // (defense in depth — the form binds them in v2026-05-03+).
            if (typeof params['tos_accepted'] === 'undefined') params['tos_accepted'] = false;
            if (!params['tos_version']) params['tos_version'] = config.tos_current_version;
            return new Promise(function (resolve, reject) {
                commit('loading');
                axios.post(config.api_url + 'signup_owner_with_subscription', params)
                    .then(response => {
                        if (response.data.code === 'ERROR') {
                            commit('status', 'error');
                            reject(response.data.message || 'Subscription failed.');
                        } else {
                            commit('success', response.data.user || {});
                            resolve(response);
                        }
                    })
                    .catch(err => {
                        commit('status', 'error');
                        // Surface backend error code + message so the
                        // component can branch on INVALID_COUPON,
                        // BILLING_TERMS_REQUIRED, etc.
                        const data = (err && err.response && err.response.data) || {};
                        reject({
                            code: data.code || 'ERROR',
                            message: data.message || 'Failed to subscribe.',
                        });
                    });
            });
        },
        // Fetch a Stripe SetupIntent client_secret used to mount the
        // embedded Payment Element on /sign_up. No auth — the new endpoint
        // is part of the public signup flow.
        fetchSignupSetupIntent: function () {
            return new Promise(function (resolve, reject) {
                axios.post(config.api_url + 'signup_owner/setup_intent', {})
                    .then(response => {
                        if (response.data.code === 'SUCCESS' && response.data.data) {
                            resolve(response.data.data);
                        } else {
                            reject(new Error('Failed to initialize payment.'));
                        }
                    })
                    .catch(err => {
                        const data = (err && err.response && err.response.data) || {};
                        reject(new Error(data.message || 'Failed to initialize payment.'));
                    });
            });
        },
        async save_customer({commit, state}, data) {
            commit("loading");
            let database = firestore;
            try {
                let query = await database.collection('tenants')
                    .doc(state.user['id'])
                    .get();

                await database.collection('tenants').doc(query.id).set({
                    customer_id: data.customer_id
                }, {merge: true});

                commit('status', '');

            } catch (error) {
                return (409).json({
                    code: config.codes.error,
                    message: error
                });
            }
        }
    }
    ,
    getters: {
        user(state) {
            return state.user;
        },
        billing(state) {
            return state.billing;
        }
    }
    ,
    modules: {}
}
